export function leadingZero(num) {
    let value = String(num);
    if (num < 10) {
        value = "0" + value;
    }
    return value;
}
